import { Injectable } from '@angular/core';
import { filter, first, last, map } from 'lodash';
import * as dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  constructor() {}

  getInOutput(collection: any, criteria: any, field: string) {
    const result = [];
    const x = filter(collection, (o) => {
      map(criteria, (p) => {
        if (o[field] === p) {
          result.push(o);
        }
      });
    });
    return result;
  }

  getFilteredData(itemCollection: any, filterCondition: any) {
    const propNames = Object.getOwnPropertyNames(filterCondition);
    let result = itemCollection;

    propNames.forEach((element) => {
      switch (element) {
        case 'equals': {
          const key = filterCondition.equals.field;
          const val = filterCondition.equals.searchString;
          if (filterCondition.equals.caseInsensitive) {
            result = filter(result, (item) => item[key].toLowerCase() === val.toLowerCase() )
          }
          else {
            result = filter(result, { [key]: val });
          }
          break;
        }
        case 'position': {
          const key = filterCondition.position.last;
          if (key) {
            const output = [];
            output.push(last(result));
            result = output;
          } else {
            const output = [];
            output.push(first(result));
            result = output;
          }
          break;
        }
        case 'numberEquals': {
          const key = filterCondition.numberEquals.field;
          const val = filterCondition.numberEquals.searchValue;

          result = filter(result, { [key]: val });
          break;
        }
        case 'in': {
          const key = filterCondition.in.field;
          const val = filterCondition.in.searchArray;
          result = this.getInOutput(itemCollection, val, key);
          break;
        }
        case 'multipleField': {
          const val = filterCondition.multipleField.searchCriteria;
          result = filter(result, val);
          break;
        }
        case 'greaterThan': {
          const key = filterCondition.greaterThan.field;
          const val = filterCondition.greaterThan.Value;
          result = filter(result, (item) => dayjs(item[key]) > dayjs(val));
          break;
        }
        case 'lessThan': {
          const key = filterCondition.lessThan.field;
          const val = filterCondition.lessThan.Value;
          result = filter(result, (item) => dayjs(item[key]) < dayjs(val));
          break;
        }
        case 'emptyField': {
          const key = filterCondition.emptyField.field;
          result = filter(result, (item) => item[key] == null);
          break;
        }
        case 'notEmptyField': {
          const key = filterCondition.notEmptyField.field;
          result = filter(result, (item) => item[key] != null);
          break;
        }
      }
    });
    return result;
  }
}
